import React, { useState } from "react";
import { Popover } from "antd";
import LanguageSwitcherWrapper from "./LanguageSwitcherWrapper.style";
import { ReactComponent as IsraelFlag } from "../../assets/flags/israel.svg";
import { ReactComponent as UKFlag } from "../../assets/flags/uk.svg";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../features/user/UserSlice";
import { FormattedMessage } from "react-intl";

const LanguageSwitcher = (props) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const language = useSelector((state) => state.user.language);
  const handleVisibleChange = () => {
    setVisible(!visible);
  };

  const onLanguageChoose = (lan) => {
    dispatch(setLanguage({ language: lan }));
    setVisible(false);
  };

  const content = (
    <LanguageSwitcherWrapper>
      <div className="list">
        <p onClick={() => onLanguageChoose("hebrew")}>עברית</p>
        <p onClick={() => onLanguageChoose("english")}>English</p>
      </div>
    </LanguageSwitcherWrapper>
  );

  return (
    <LanguageSwitcherWrapper>
      <Popover
        title={<FormattedMessage id="app.topbar.chooseLanguage" />}
        content={content}
        placement={"bottomLeft"}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        arrow={{ pointAtCenter: true }}
      >
        <div className="container">
          {language === "english" ? "English" : "עברית"}
        </div>
      </Popover>
    </LanguageSwitcherWrapper>
  );
};

export default LanguageSwitcher;
